var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "courseware-unit-item",
    },
    [
      _c("courseware-tile", {
        attrs: {
          tag: "div",
          color: _vm.color,
          title: _vm.title,
          descriptionLink: _vm.url,
          descriptionTitle: _vm.$gettext("Lernmaterial öffnen"),
          displayProgress: _vm.inCourseContext,
          progress: _vm.progress,
          imageUrl: _vm.imageUrl,
        },
        scopedSlots: _vm._u([
          {
            key: "image-overlay-with-action-menu",
            fn: function fn() {
              return [
                _c("studip-action-menu", {
                  staticClass: "cw-unit-action-menu",
                  attrs: {
                    items: _vm.menuItems,
                    context: _vm.title,
                    collapseAt: 0,
                  },
                  on: {
                    showDelete: _vm.openDeleteDialog,
                    showExport: _vm.openExportDialog,
                    showProgress: _vm.openProgressDialog,
                    showSettings: _vm.openSettingsDialog,
                    copyUnit: _vm.copy,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "description",
            fn: function fn() {
              return [
                _vm._v(
                  "\n            " + _vm._s(_vm.description) + "\n        "
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.showDeleteDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Lernmaterial löschen"),
              question: _vm.$gettextInterpolate(
                _vm.$gettext(
                  "Möchten Sie das Lernmaterial %{ unitTitle } wirklich löschen?"
                ),
                {
                  unitTitle: _vm.title,
                }
              ),
              height: "200",
            },
            on: {
              confirm: _vm.executeDelete,
              close: _vm.closeDeleteDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showProgressDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.userIsTeacher
                ? _vm.$gettext("Fortschritt aller Teilnehmenden")
                : _vm.$gettext("Mein Fortschritt"),
              closeText: _vm.$gettext("Schließen"),
              closeClass: "cancel",
              width: "800",
              height: "600",
            },
            on: {
              close: _vm.closeProgressDialog,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c("courseware-unit-progress", {
                        attrs: {
                          progressData: _vm.progresses,
                          unitId: _vm.unit.id,
                          rootId: parseInt(_vm.unitElement.id),
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3003099453
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showExportDialog
        ? _c("courseware-unit-item-dialog-export", {
            attrs: {
              unit: _vm.unit,
            },
            on: {
              close: function close($event) {
                _vm.showExportDialog = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSettingsDialog
        ? _c("courseware-unit-item-dialog-settings", {
            attrs: {
              unit: _vm.unit,
            },
            on: {
              close: _vm.closeSettingsDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }